import { lazy } from 'react'

import { Benefits as Icon } from '@factorialco/factorial-one-react/icons/modules'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import BenefitsLandingPage from 'modules/benefits/pages/BenefitsLanding'

const RootPage = lazy(() => import('modules/benefits/pages/RootPage'))

const BenefitsGuardPage = lazy(() => import('modules/benefits/pages/BenefitsActiveGuardPage'))
const BenefitsHomePage = lazy(() => import('modules/benefits/pages/BenefitsHomePage'))
const AccountsPage = lazy(() => import('modules/benefits/pages/AccountsPage'))
const UsagePage = lazy(() => import('modules/benefits/pages/UsagePage'))
const EmployeesPage = lazy(() => import('modules/benefits/pages/EmployeesPage'))
export const benefitsRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.benefits.path,
    handle: {
      module: 'benefits',
      moduleIcon: Icon,
      moduleName: () => i18n.t('benefits.module_name'),
      meta: () => ({
        title: i18n.t('benefits.module_name'),
        description: i18n.t('payroll_bundle.payroll_issues.description'),
      }),
    },
    element: <RootPage />,
    children: [
      {
        element: <BenefitsGuardPage />,
        handle: {
          meta: () => ({
            title: i18n.t('benefits.module_name'),
            description: i18n.t('payroll_bundle.payroll_issues.description'),
            subNavigation: [
              {
                title: i18n.t('benefits.tabs.overview.title'),
                href: navigation.benefits.fullPath(),
                index: true,
              },
              {
                title: i18n.t('benefits.tabs.accounts.title'),
                href: navigation.benefits.accounts.fullPath(),
              },
              {
                title: i18n.t('benefits.tabs.employees.page.title'),
                href: navigation.benefits.employees.fullPath(),
              },
              {
                title: i18n.t('benefits.tabs.usage.title'),
                href: navigation.benefits.usage.fullPath(),
              },
            ],
          }),
        },

        children: [
          {
            index: true,
            element: <BenefitsHomePage />,
          },
          {
            path: navigation.benefits.accounts.path,
            element: <AccountsPage />,
          },
          {
            path: navigation.benefits.usage.path,
            element: <UsagePage />,
          },
          {
            path: navigation.benefits.employees.path,
            element: <EmployeesPage />,
          },
        ],
      },
      {
        path: navigation.benefits.landing.path,
        element: <BenefitsLandingPage />,
      },
    ],
  },
]
